module.exports.DOCTOR_LINKS = [
    {
        label: 'consultations',
        path: '/home',
        isNeedFullAccess: true,
    },
    {
        label: 'messages',
        path: '/messages',
        isNeedFullAccess: true,
        counterName: 'messages',
    },
    {
        label: 'my-profile',
        path: '/profile',
        isNeedFullAccess: false,
    },
    {
        label: 'patients',
        path: '/doctor/patients',
        isNeedFullAccess: true,
    },
    {
        label: 'documents-label',
        path: '/doctor/documents',
        isNeedFullAccess: true,
        counterName: 'faxes',
    },
    {
        label: 'contacts',
        path: '/doctor/contacts',
    },
    {
        label: 'tasks',
        path: '/doctor/tasks',
    },
    ,
    {
        label: 'transactions',
        path: '/transactions',
        isNeedFullAccess: true,
    }
];


module.exports.GUEST_LINKS = [
    {
        id: 'home',
        path: '/',
        label: 'home',
    },
    // {
    //     id: 'how-it-works',
    //     path: '/#how-it-works',
    //     label: 'features',
    // },
    {
        id: 'plan-and-prices',
        path: 'https://app.cirrusmed.com/landing#plan-and-prices',
        label: 'plans-and-prices',
        isExternal: true
    },
    {
        id: 'services',
        path: 'https://app.cirrusmed.com/landing#services',
        label: 'services',
        isExternal: true
    },
    {
        id: 'conditions-treated',
        label: 'conditions-treated',
        path: 'https://app.cirrusmed.com/conditions-treated',
        commonLink: true,
        isExternal: true
    },
    {
        id: 'doctors',
        label: 'doctors',
        path: 'https://app.cirrusmed.com/doctors',
        commonLink: true,
        isExternal: true
    },
    {
        id: "faq",
        label: "FAQ",
        isExternal: true,
        path: "https://cirrusmedicalnetwork.com/faq-2/"
    }
    /* ,
    {
        id: 'our-customers',
        path: '/#our-customers',
        label: 'our-customers'
    }
    ,
    {
        id: 'ask-now',
        path: '/#ask-now',
        label: 'ask-now'
    } */
];

module.exports.PATIENT_LINKS = [
    {
        label: 'home',
        path: '/home',
        isNeedFullAccess: false,
        showIfFullAccess: true,
    },
    {
        label: 'profile',
        path: '/profile',
        isNeedFullAccess: false,
        showIfFullAccess: true,
    },
    {
        label: 'doctors',
        path: '/doctors',
        isNeedFullAccess: false,
        showIfFullAccess: true,
    },
    {
        label: 'messages',
        path: '/messages',
        counterName: 'messages',
        showIfFullAccess: true,
    },
    {
        label: 'settings',
        path: '/settings',
        isNeedFullAccess: false,
        showIfFullAccess: true
    },
];

module.exports.ADMIN_LINKS = [
    {
        label: 'applications',
        path: '/admin',
    },
    {
        label: 'providers',
        path: '/admin/providers',
    },
    {
        label: 'patients',
        path: '/admin/patients',
    },
    {
        label: 'contacts',
        path: '/admin/contacts',
    },
    {
        label: 'tasks',
        path: '/admin/tasks',
    },
    {
        label: 'messages',
        path: '/messages',
        counterName: 'messages',
    },
    {
        label: 'transactions',
        path: '/admin/transactions',
    },
    {
        label: 'packages',
        path: '/admin/packages',
    },
    {
        label: 'promo-codes',
        path: '/admin/promo-codes',
    },
    {
        label: 'documents-label',
        path: '/admin/documents',
        counterName: 'faxes',
    },
    {
        label: 'reviews',
        path: '/admin/reviews',
        counterName: 'faxes',
    },
    {
        label: 'settings',
        path: '/settings',
    },
];

module.exports.VMA_LINKS = [
    {
        label: 'patients',
        path: '/vma/patients',
    },
    {
        label: 'contacts',
        path: '/vma/contacts',
    },
    {
        label: 'messages',
        path: '/messages',
        counterName: 'messages',
    },
    {
        label: 'doctors',
        path: '/vma/doctors',
    },
    {
        label: 'tasks',
        path: '/vma/tasks',
    },
    {
        label: 'documents-label',
        path: '/vma/documents',
        counterName: 'faxes',
    },
    {
        label: 'transactions',
        path: '/vma/transactions',
    }
];



// WEBPACK FOOTER //
// ./src/sources/constants/headerLinks.js